"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LineString = _interopRequireDefault(require("../../geom/LineString"));

var _Coordinate = _interopRequireDefault(require("../../geom/Coordinate"));

var _Point = _interopRequireDefault(require("../../geom/Point"));

var _Polygon = _interopRequireDefault(require("../../geom/Polygon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RectangleContains =
/*#__PURE__*/
function () {
  function RectangleContains() {
    _classCallCheck(this, RectangleContains);

    RectangleContains.constructor_.apply(this, arguments);
  }

  _createClass(RectangleContains, [{
    key: "isContainedInBoundary",
    value: function isContainedInBoundary(geom) {
      if (geom instanceof _Polygon.default) return false;
      if (geom instanceof _Point.default) return this.isPointContainedInBoundary(geom);
      if (geom instanceof _LineString.default) return this.isLineStringContainedInBoundary(geom);

      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var comp = geom.getGeometryN(i);
        if (!this.isContainedInBoundary(comp)) return false;
      }

      return true;
    }
  }, {
    key: "isLineSegmentContainedInBoundary",
    value: function isLineSegmentContainedInBoundary(p0, p1) {
      if (p0.equals(p1)) return this.isPointContainedInBoundary(p0);

      if (p0.x === p1.x) {
        if (p0.x === this._rectEnv.getMinX() || p0.x === this._rectEnv.getMaxX()) return true;
      } else if (p0.y === p1.y) {
        if (p0.y === this._rectEnv.getMinY() || p0.y === this._rectEnv.getMaxY()) return true;
      }

      return false;
    }
  }, {
    key: "isLineStringContainedInBoundary",
    value: function isLineStringContainedInBoundary(line) {
      var seq = line.getCoordinateSequence();
      var p0 = new _Coordinate.default();
      var p1 = new _Coordinate.default();

      for (var i = 0; i < seq.size() - 1; i++) {
        seq.getCoordinate(i, p0);
        seq.getCoordinate(i + 1, p1);
        if (!this.isLineSegmentContainedInBoundary(p0, p1)) return false;
      }

      return true;
    }
  }, {
    key: "isPointContainedInBoundary",
    value: function isPointContainedInBoundary() {
      if (arguments[0] instanceof _Point.default) {
        var point = arguments[0];
        return this.isPointContainedInBoundary(point.getCoordinate());
      } else if (arguments[0] instanceof _Coordinate.default) {
        var pt = arguments[0];
        return pt.x === this._rectEnv.getMinX() || pt.x === this._rectEnv.getMaxX() || pt.y === this._rectEnv.getMinY() || pt.y === this._rectEnv.getMaxY();
      }
    }
  }, {
    key: "contains",
    value: function contains(geom) {
      if (!this._rectEnv.contains(geom.getEnvelopeInternal())) return false;
      if (this.isContainedInBoundary(geom)) return false;
      return true;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RectangleContains;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "contains",
    value: function contains(rectangle, b) {
      var rc = new RectangleContains(rectangle);
      return rc.contains(b);
    }
  }]);

  return RectangleContains;
}();

exports.default = RectangleContains;

RectangleContains.constructor_ = function () {
  this._rectEnv = null;
  var rectangle = arguments[0];
  this._rectEnv = rectangle.getEnvelopeInternal();
};